import React from 'react';
import Navbar from './Navbar';
import Hero from '../Sections/Hero';

const Header = () => {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  );
};

export default Header;